import { render, staticRenderFns } from "./ConfigurazioniMagazzinoArticoliMarcaListPage.vue?vue&type=template&id=6815457e"
import script from "./ConfigurazioniMagazzinoArticoliMarcaListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioniMagazzinoArticoliMarcaListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports